<template>
  <footer class="footer-content">
    <div class="footer-bg2">
      <div class="main">
        <div class="left-section">
          <p class="friend-title">{{this.$t('common.CommendLinks')}}</p>
          <ul>
            <li><a href="http://www.whdata.cn/" target="_blank">武汉天浩数据恢复</a></li>
            <!--<li><a href="">张磊硬盘维修论坛</a></li>-->
            <li><a href="http://www.267267.com/"  target="_blank">沈阳数据恢复</a></li>
            <li><a href="http://www.jsos.cn/" target="_blank">南京西数科技</a></li>
            <!--<li><a href="">中国硬盘配件网</a></li>-->
            <li><a href="http://www.13303406319.com/" target="_blank">金臣太原数据恢复中心</a></li>
            <!--<li><a href="">扬州飞浩数据恢复</a></li>-->
            <li><a href="http://bbs.intohard.com/" target="_blank">INTOHARD数据恢复之家</a></li>
            <!--<li><a href="">众诚数据恢复</a></li>-->
            <!--<li><a href="">宁波数据恢复</a></li>-->
            <li><a href="http://www.datasd.net/" target="_blank">天和数据恢复中心</a></li>
            <li><a href="http://www.plantseq.org/" target="_blank">ENPG</a></li>
          </ul>
        </div>
        <div class="right-section">
          <p class="friend-title">{{this.$t('common.NavigationLink')}}</p>
          <ul>
            <li v-for="(item,index) in navList"
                @click="routerLink(index, item.path)"> {{item.title }}
            </li>
            <li class="menu-out" @click="Firmware"> {{this.$t('common.Firmware')}}</li>
            <li class="menu-out" @click="Support">{{this.$t('common.Support')}}</li>
            <li class="menu-out" @click="Products">{{this.$t('common.Products')}}</li>
            <li class="menu-out"  @click="Users">{{this.$t('common.userCenter')}}</li>
          </ul>
        </div>

      </div>

    </div>
    <div class="footer-bg1">
      <p>{{this.$t('common.SiteName')}}：www.mrtlab.com | {{this.$t('common.groups')}}：250649022 | <span @click="terms">{{this.$t('common.Terms')}}</span> |
        <a href="http://www.beian.miit.gov.cn" target="_blank">{{this.$t('common.Record')}}</a></p>
      <p>{{this.$t('common.MRTIntroduction')}}</p>
      <p>Copyright 2003-{{year}} Powered By MrtLab </p>
    </div>

  </footer>
</template>

<script>

  export default {
    name: 'footerComponent',
    data() {
      return {
        navList: [
          {title: this.$t('common.home'), path: '/', uri: 'home'},
          {title: this.$t('common.IndustryNews'), path: '/industryNews', uri: 'news'},
          {title: this.$t('common.TutorialsData'), path: '/tutorial', uri: 'tutorial'},
          {title: this.$t('common.IndustryTalk'), path: '/industryTalk', uri: 'news'},
          {title: this.$t('common.Software'), path: '/software', uri: 'software'},
          // {title: '图片资料', path: '/imgList',uri:'picture'},
          {title: this.$t('common.Website'), path: '/website', uri: 'website'},
          {title: this.$t('common.PaidSubmission'), path: '/submission'},
        ],
        year:'',
      }
    },
    created: function () {
      //版权信息Copyright 动态获取当前年份
      var nowDate = new Date();
      this.year=nowDate.getFullYear();
    },
    methods: {
      /**导航跳转* 路由跳转*/
      routerLink(index, path) {
        //页面导航高亮
        var localUri = this.navList[index].uri;
        sessionStorage.setItem('type1', localUri);
        sessionStorage.setItem('menuIndex', index);
        // 路由跳转
        if (path == '/submission') {
          // sessionStorage.setItem('type1', 'submission');
          // window.location.href = '/submission';
          // return;
          this.$router.push(path);
          window.location.reload();
          return;
        }
        this.$router.push(path);
      },

      // 跳转固件云页面
      Firmware(){
        var token=localStorage.getItem('loginToken');
        var nickname=localStorage.getItem('nickname');
        // console.log(token);
        var url='http://hdd.mrtlab.com/firmware';
        if(token !='' && token !=null){
          url+='?token='+token+'&nickname='+nickname;
        }
        window.open(url,'_black')
      },
      Support(){
        window.open('https://vip.mrtlab.com/login.jsp?tourl=suptask.jsp','_black')
        var lang = this.$store.state.lang
        if(lang==='en'){
          window.open('https://vip.mrtlab.com/en/login.jsp?tourl=suptask.jsp','_black');
        }else if(lang=='zh'){
          window.open('https://vip.mrtlab.com/login.jsp?tourl=suptask.jsp','_black')
        }
      },

      //跳转到产品专栏
      Products(){
        var lang = this.$store.state.lang
        if(lang==='en'){
          window.open('http://us.mrtlab.com/prodindex.htm','_black');
        }else if(lang==='zh'){
          window.open('http://info.mrtlab.com/prodindex.htm','_black')
        }

      },
      Users() {
        var lang = this.$store.state.lang
        if (lang === 'en') {
          window.open('https://vip.mrtlab.com/en/', '_black');
        } else if (lang === 'zh') {
          window.open('https://vip.mrtlab.com/', '_black')
        }
      },

      terms() {
        var lang = this.$store.state.lang
        var a = document.createElement("a");
        a.setAttribute("target", "_blank");
        if (lang === 'en') {
          a.setAttribute("href", "http://en.mrtlab.com/terms-of-use");
          } else if (lang === 'zh') {
          a.setAttribute("href", "http://cn.mrtlab.com/%E4%BD%BF%E7%94%A8%E6%9D%A1%E6%AC%BE");
          }
        a.click();
      }
      },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main {
    width: 1170px;
    margin: 0 auto;
    display: flex;
  }
  .left-section{
    width: 50%;
  }
  .right-section {
    width: 50%;
  }
  .friend-title {
    font-size: 16px;
    text-align: left;
    padding-left: 10px;
    padding-bottom: 5px;
    color: #fff;
  }

  .footer-bg1 {
    background:#000;
    text-align: center;
    padding: 10px 0;
    width: 100%;
    margin: auto;
    border-top: #555 1px solid;
  }

  .footer-bg1 p {
    margin: 5px 0;
    color: #c2c2c2;
    font-size: 12px;
  }

  .footer-bg1 p a,span {
    cursor: pointer;
    color: #c2c2c2;
    text-decoration: none;
  }

  .footer-bg2 {
    background: #333;
    padding: 10px 0;
    width: 100%;
  }

  .footer-bg2 ul {
    width:100%;
    margin: auto;
    padding: 0 0;
    display: flex;
    flex-wrap: wrap;
  }

  .right-section ul li, .left-section ul li a {
    display: block;
    color: #c2c2c2;
    padding: 5px 10px;
    text-decoration: none;
  }
  .right-section ul li a {
    color: #c2c2c2;
    text-decoration: none;
  }
  .footer-bg2 ul li:hover {cursor: pointer; color: #fff;}


  @media screen and (max-width: 1024px) {
    .main {
      width: 100%;
    }
    .right-section,.left-section {
      width: 100%;
    }









  }
</style>



// WEBPACK FOOTER //
// src/components/footerNew.vue